export const AVATAR_PRESETS = ["av1", "av2", "av3", "av4", "av5", "av6", "av7", "av8"];
